<div class="bn-notifications">
  @if (isMobile) {
    <div class="bn-notifications__mobile d-flex justify-content-between align-items-center">
      <fa-icon
        class="bn-notifications__mobile__icon"
        icon="bell" />
      <a
        class="bn-notifications__mobile__link flex-grow-1"
        routerLink="/notifications"
        routerLinkActive="bn-notifications__mobile__link--active"
        >Changelog &amp; Notifications</a
      >
      @if ((userFeedUnread$ | async)?.length) {
        <bn-web-ui-badge
          appearance="solid"
          color="red"
          contentClass="bn-notifications__badge--mobile"
          size="xs"
          type="pill"
          >{{ (userFeedUnread$ | async)?.length }}</bn-web-ui-badge
        >
      }
    </div>
  }
  @if (!isMobile) {
    <bn-web-ui-dropdown-menu
      [aboveLoader]="true"
      [options]="{ size: 'lg', indent: '-18px' }"
      (dropDownStateChanged)="onCloseDropdown($event)">
      <div
        class="bn-notifications__trigger"
        trigger>
        <fa-icon
          class="bn-notifications__icon"
          icon="bell" />
        @if ((userFeedUnread$ | async)?.length) {
          <bn-web-ui-badge
            appearance="solid"
            color="red"
            contentClass="bn-notifications__badge"
            size="xs"
            type="pill"
            >{{ (userFeedUnread$ | async)?.length }}</bn-web-ui-badge
          >
        }
      </div>
      <div
        class="bn-notifications"
        content>
        <div class="bn-dropdown__header bn-notifications__header">
          <div class="bn-level">
            <div class="bn-level--left">
              <div class="bn-notifications__title">Changelog &amp; Notifications</div>
            </div>
          </div>
        </div>
        @if ((userFeed$ | async)?.length) {
          <ul class="bn-notifications__list">
            @for (notification of (userFeed$ | async)?.slice(0, showLastLength); track `${notification.id}-${notification.type}`) {
              <li
                class="bn-dropdown__item bn-notifications__item"
                [ngClass]="{ 'bn-notifications__item--new': !notification.isRead }">
                <a
                  class="bn-notifications__link"
                  fragment="{{ notification.timestamp | date: 'yyyy-MM-dd' }}"
                  routerLink="/notifications">
                </a>
                <bn-web-ui-notification-item [notification]="notification" />
              </li>
            }
          </ul>
        } @else {}
        <div class="bn-dropdown__item bn-notifications__actions">
          <a
            bn-web-ui-button
            itemStyle="secondary"
            routerLink="/notifications"
            size="lg"
            [fullWidth]="true">
            Show all
          </a>
        </div>
      </div>
    </bn-web-ui-dropdown-menu>
  }
</div>
